var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_8601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 0.909102C18.2601 0.909337 21.4192 2.03992 23.939 4.10821C26.4589 6.1765 28.1836 9.05453 28.8194 12.2519C29.4552 15.4493 28.9627 18.7682 27.4257 21.6432C25.8888 24.5182 23.4026 26.7713 20.3907 28.0186C17.3787 29.266 14.0275 29.4304 10.9079 28.4839C7.78839 27.5374 5.09353 25.5385 3.28253 22.8278C1.47153 20.1171 0.656442 16.8624 0.976151 13.6181C1.29586 10.3738 2.73058 7.34077 5.03586 5.03572C6.34293 3.72528 7.89611 2.68609 9.60613 1.9779C11.3161 1.26971 13.1493 0.906487 15.0001 0.909102ZM5.81183 23.0909C6.66637 21.3886 7.97807 19.9579 9.59994 18.959C11.2218 17.9602 13.0898 17.4328 14.9945 17.4358C16.8993 17.4389 18.7656 17.9722 20.3843 18.9762C22.003 19.9802 23.3101 21.4151 24.1592 23.1201C25.7232 21.3563 26.7448 19.1785 27.1012 16.8482C27.4576 14.5179 27.1337 12.1343 26.1684 9.9836C25.2031 7.83292 23.6374 6.00665 21.6594 4.72413C19.6815 3.44161 17.3753 2.75739 15.0179 2.75363C12.6606 2.74988 10.3522 3.42675 8.37018 4.70297C6.38814 5.97918 4.81666 7.80046 3.84451 9.94804C2.87236 12.0956 2.54087 14.4782 2.88985 16.8096C3.23883 19.141 4.25344 21.3221 5.81183 23.0909ZM15.0229 4.58442C13.7249 4.5846 12.4671 5.03483 11.4639 5.8584C10.4606 6.68196 9.77397 7.82791 9.52091 9.10098C9.26785 10.3741 9.46404 11.6955 10.076 12.8401C10.688 13.9848 11.678 14.8818 12.8772 15.3784C14.0765 15.875 15.4108 15.9404 16.6528 15.5634C17.8949 15.1865 18.9678 14.3906 19.6888 13.3113C20.4098 12.232 20.7343 10.936 20.6069 9.64432C20.4796 8.3526 19.9083 7.145 18.9904 6.22728C18.4694 5.70776 17.8512 5.29609 17.1709 5.01586C16.4907 4.73563 15.7618 4.59233 15.0261 4.59416L15.0229 4.58442Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_8601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.d7318d3bc2ed3198882b427d70089581.svg";
export { ForwardRef as ReactComponent };